var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.98 0C8.94 0 0 8.96 0 20C0 31.04 8.94 40 19.98 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 19.98 0ZM28 28C27.815 28.1854 27.5952 28.3325 27.3532 28.4329C27.1113 28.5332 26.8519 28.5849 26.59 28.5849C26.3281 28.5849 26.0687 28.5332 25.8268 28.4329C25.5848 28.3325 25.365 28.1854 25.18 28L18.6 21.42C18.411 21.2348 18.2607 21.0139 18.1577 20.7701C18.0547 20.5264 18.0011 20.2646 18 20V12C18 10.9 18.9 10 20 10C21.1 10 22 10.9 22 12V19.18L28 25.18C28.78 25.96 28.78 27.22 28 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.050add09346e0e0ff680b116336efcef.svg";
export { ForwardRef as ReactComponent };